import PageLoadingIndicator from '../components/loading-indicators/page';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import vtLogo from '@llt-frontend/brands/varsity-tutors/b.svg';
import vtLogoMark from '@llt-frontend/brands/varsity-tutors/e.svg';

import { ContentUnderTopAppBar, TopAppBar } from '@llt-frontend/react-material-top-app-bar';

//

function SecondaryLayout({ children, className, withoutLabBranding = false }) {
  return (
    <div
      className={classnames('secondary-layout', className, {
        'secondary-layout--without-lab-branding': withoutLabBranding,
      })}
    >
      <TopAppBar className="site-header">
        <a href="/learning-lab" title="Varsity Tutors homepage">
          <img
            alt=""
            className="mdc-top-app-bar__site-logo"
            src={withoutLabBranding ? vtLogo : vtLogoMark}
          />
        </a>

        {!withoutLabBranding && <span className="site-header__app-name">Learning Lab</span>}
      </TopAppBar>

      <ContentUnderTopAppBar className="main" component="main" role="main">
        <div className="main-content" id="main-content">
          {children}
        </div>

        <PageLoadingIndicator />
      </ContentUnderTopAppBar>
    </div>
  );
}

SecondaryLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  withoutLabBranding: PropTypes.bool,
};

// Exports
// -------

export default SecondaryLayout;
